export default __webpack_public_path__ + "static/media/add-calendar-icon.73f1fbde.png";